module.exports = __webpack_public_path__ + "assets/16.jpg?86892064b4628fb9f8412abdd9553aae";